// extracted by mini-css-extract-plugin
export default {"container":"FileInput_container__j0BEe"};